import React, { useState } from 'react';

const JERUSALEM_GOLD = "#c5a059"; 
const VINTAGE_BEIGE = "#e5d1a5";

const TaskForm = ({ onTaskAdded }) => {
  const [text, setText] = useState('');
  const [stat, setStat] = useState('vision');
  const [val, setVal] = useState(10);
  
  // Custom Dropdown durumları
  const [isStatOpen, setIsStatOpen] = useState(false);
  const [isDiffOpen, setIsDiffOpen] = useState(false);

  // Güncel Emojiler ve Statlar
  const stats = [
    { id: 'vision', label: 'Vision (🕯️)' },
    { id: 'intelligence', label: 'Intelligence (📜)' },
    { id: 'discipline', label: 'Discipline (⚔️)' },
    { id: 'energy', label: 'Energy (🔥)' },
    { id: 'wealth', label: 'Wealth (⚜️)' }
  ];

  // Kusursuz 4 Seviyeli XP Sistemi
  const difficulties = [
    { value: 10, label: 'Easy (+10 XP)' },
    { value: 20, label: 'Medium (+20 XP)' },
    { value: 30, label: 'Hard (+30 XP)' },
    { value: 50, label: 'Epic (+50 XP)' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    
    onTaskAdded({
      id: Date.now(),
      text,
      stat,
      val
    });
    
    setText('');
    // Formu sıfırladıktan sonra menüleri kapat
    setIsStatOpen(false);
    setIsDiffOpen(false);
  };

  const currentStatLabel = stats.find(s => s.id === stat)?.label || 'Vision (🕯️)';
  const currentDiffLabel = difficulties.find(d => d.value === val)?.label || 'Easy (+10 XP)';

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
      
      {/* GÖREV METNİ (Silik yazılar düzeltildi) */}
      <input
        type="text"
        placeholder="What must be done..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{
          width: '100%',
          backgroundColor: 'transparent',
          border: 'none',
          borderBottom: `1px solid ${JERUSALEM_GOLD}`,
          color: '#fdfbf7',
          padding: '10px 5px',
          outline: 'none',
          fontFamily: 'Courier Prime, monospace',
          fontSize: '1rem'
        }}
        className="quest-input"
      />

      <div style={{ display: 'flex', gap: '15px', position: 'relative' }}>
        
        {/* STAT SEÇİMİ (CUSTOM DROPDOWN) */}
        <div style={{ flex: 1, position: 'relative' }}>
          <div 
            onClick={() => { setIsStatOpen(!isStatOpen); setIsDiffOpen(false); }}
            style={{
              padding: '10px 15px', backgroundColor: 'rgba(0,0,0,0.4)', border: `1px solid rgba(197, 160, 89, 0.3)`, 
              color: VINTAGE_BEIGE, cursor: 'pointer', fontFamily: 'Courier Prime, monospace',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '2px'
            }}
          >
            <span>{currentStatLabel}</span>
            <span style={{ fontSize: '0.8rem', color: JERUSALEM_GOLD }}>▼</span>
          </div>
          
          {isStatOpen && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, backgroundColor: 'var(--sidebar-bg)', border: `1px solid ${JERUSALEM_GOLD}`, borderTop: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.8)' }}>
              {stats.map(s => (
                <div 
                  key={s.id}
                  onClick={() => { setStat(s.id); setIsStatOpen(false); }}
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(139,58,58,0.3)'; e.currentTarget.style.color = JERUSALEM_GOLD; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = VINTAGE_BEIGE; }}
                  style={{ padding: '10px 15px', cursor: 'pointer', fontFamily: 'Courier Prime, monospace', color: VINTAGE_BEIGE, borderBottom: '1px solid rgba(197,160,89,0.1)' }}
                >
                  {s.label}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ZORLUK/XP SEÇİMİ (CUSTOM DROPDOWN) */}
        <div style={{ flex: 1, position: 'relative' }}>
          <div 
            onClick={() => { setIsDiffOpen(!isDiffOpen); setIsStatOpen(false); }}
            style={{
              padding: '10px 15px', backgroundColor: 'rgba(0,0,0,0.4)', border: `1px solid rgba(197, 160, 89, 0.3)`, 
              color: VINTAGE_BEIGE, cursor: 'pointer', fontFamily: 'Courier Prime, monospace',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '2px'
            }}
          >
            <span>{currentDiffLabel}</span>
            <span style={{ fontSize: '0.8rem', color: JERUSALEM_GOLD }}>▼</span>
          </div>
          
          {isDiffOpen && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, backgroundColor: 'var(--sidebar-bg)', border: `1px solid ${JERUSALEM_GOLD}`, borderTop: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.8)' }}>
              {difficulties.map(d => (
                <div 
                  key={d.value}
                  onClick={() => { setVal(d.value); setIsDiffOpen(false); }}
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(139,58,58,0.3)'; e.currentTarget.style.color = JERUSALEM_GOLD; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = VINTAGE_BEIGE; }}
                  style={{ padding: '10px 15px', cursor: 'pointer', fontFamily: 'Courier Prime, monospace', color: VINTAGE_BEIGE, borderBottom: '1px solid rgba(197,160,89,0.1)' }}
                >
                  {d.label}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <button 
        type="submit" 
        style={{
          width: '100%', padding: '12px', marginTop: '5px', backgroundColor: 'var(--accent-red)',
          color: JERUSALEM_GOLD, border: '1px solid #5a0d0e', fontFamily: 'Cinzel, serif',
          fontWeight: 'bold', letterSpacing: '2px', cursor: 'pointer', borderRadius: '2px', transition: '0.2s'
        }}
        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; }}
        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e'; }}
      >
        ADD QUEST
      </button>
      
    </form>
  );
};

export default TaskForm;